<template>
  <scoped>
    <label
      v-if="title"
      :for="id"
    >
      {{ title }}
    </label>
    <span
      v-for="option of options"
      :id="id"
      :key="option"
    >
      <input
        :id="`${id}-${option}`"
        v-model="selection"
        :value="option"
        type="radio"
        :disabled="readOnly"
        @change="emits('update')"
      >
      <label :for="`${id}-${option}`">
        {{ option }}
      </label>
    </span>
  </scoped>
</template>

<script setup lang="ts">
  import {useId} from "vue"

  defineProps({
    options: {
      default: null,
      required: true,
      type: Array<string>
    },
    readOnly: {
      default: false,
      required: false,
      type: Boolean
    },
    title: {
      default: null,
      required: false,
      type: String
    }
  })

  const emits = defineEmits(["update"])
  const id = useId()
  const selection = defineModel("selection", {
    default: null,
    required: true,
    type: String
  })
</script>

<style scoped>
  label {
    display: block;
    font-weight: bolder;
  }

  span {
    display: block;

    > input[type = "radio"] {
      cursor: pointer;
      display: inline;
      margin: 0.5em 0.5em 0 0;

      &:before {
        border-color: var(--theme-color-primary);
        border-radius: var(--border-radius-small);
        border-style: solid;
        border-width: var(--border-width-light);
        color: var(--color-white);
        content: "-";
        display: inline-block;
        text-align: center;
        width: 1.5em;
      }

      &:checked {
        &:before {
          color: var(--color-green);
          content: "\2714";
        }
      }
    }

    > label {
      cursor: pointer;
      display: inline;
      font-weight: normal;
    }
  }
</style>
